const r = (t) => t.toString().padStart(2, "0");
export {
  r as padWithZero
};
//# sourceMappingURL=number.es.js.map
